export interface Affiliate {
  id: string;
  name: string;
  address: string | null;
  city: string | null;
  country_code: string | null;
  phone: string | null;
  whatsapp: string | null;
  contact_email: string | null;
  subscription_status: string;
  member_count: number;
  owner: {
    id: string;
    name: string;
    email: string;
  };
  agent?: {
    id: string;
    name: string;
    territory_name: string | null;
  } | null;
  recommended_by?: {
    name: string;
    recommended_at: string;
  } | null;
  created_at: string;
  source?: 'affiliate' | 'application';
}

export interface AffiliateAgent {
  id: string;
  name: string;
  territory_name: string | null;
}

export interface AffiliateOwnerOption {
  id: string;
  name: string;
  email: string;
}

export interface PendingAffiliate {
  id: string;
  name: string;
  address: string | null;
  country_code: string | null;
  phone: string | null;
  whatsapp: string | null;
  contact_email: string | null;
  member_count: number;
  status: string;
  source?: 'affiliate' | 'application';
  owner: {
    id?: string | null;
    name?: string | null;
    email?: string | null;
  };
  created_at: string;
}

export const affiliateStatusLabels: Record<string, string> = {
  pending: 'Pending',
  active: 'Active',
  cancelled: 'Suspended',
  past_due: 'Past Due',
};

export const affiliateStatusColors: Record<string, string> = {
  pending: 'bg-orange-500/10 text-orange-500 border-orange-500/20',
  active: 'bg-green-500/10 text-green-500 border-green-500/20',
  cancelled: 'bg-red-500/10 text-red-500 border-red-500/20',
  past_due: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
};

export function mapPendingAffiliate(affiliate: PendingAffiliate): Affiliate {
  return {
    id: affiliate.id,
    name: affiliate.name,
    address: affiliate.address,
    city: null,
    country_code: affiliate.country_code,
    phone: affiliate.phone,
    whatsapp: affiliate.whatsapp,
    contact_email: affiliate.contact_email,
    subscription_status: affiliate.status,
    member_count: affiliate.member_count,
    owner: {
      id: affiliate.owner.id || '',
      name: affiliate.owner.name || '',
      email: affiliate.owner.email || '',
    },
    agent: null,
    created_at: affiliate.created_at,
    source: affiliate.source,
  };
}

export function formatAffiliateDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}
